import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'components/Icon';

import { PVI_NO_STYLES_CLASSNAME } from 'utils/helpers/inclusion';
import styles from './styles.module.scss';

const MapSwitchButton = ({ isMapOpen = false, toggleMap }) => (
	<button
		type="button"
		onClick={toggleMap}
		className={styles.Button}
		tabIndex="-1"
		aria-hidden="true"
	>
		<Icon
			icon={isMapOpen ? 'list' : 'location'}
			className={cx(styles.Button_Icon, PVI_NO_STYLES_CLASSNAME)}
			useClassName={PVI_NO_STYLES_CLASSNAME}
		/>
		<span className={styles.Button_Text}>
			{isMapOpen ? 'Списком' : 'На карте'}
		</span>
	</button>
);

MapSwitchButton.propTypes = {
	toggleMap: PropTypes.func.isRequired,
	isMapOpen: PropTypes.bool
};

export default MapSwitchButton;
